// Mock data for Capital View LLC properties and business info

export const properties = [
  {
    id: 'cv-001',
    name: 'Capitol Hill 1',
    location: '220 14th Street SE, Capitol Hill, Washington DC',
    coordinates: { lat: 38.8847, lng: -76.9833 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/capital-hill-1/cfcaeb',
    bedrooms: 5,
    bathrooms: 4.5,
    sleeps: 10,
    pricePerNight: 350,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 3 },
      { type: 'Bunk Bed', count: 2 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/dl2lv6gr_37.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/qc6rzxen_26.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/lluixi29_39.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/35awywiy_30.jpg'
    ],
    description: 'Stunning 5-bedroom, 4.5-bath home in the heart of Capitol Hill, just steps from the U.S. Capitol, Supreme Court, and Eastern Market. This beautifully appointed property sleeps up to 10 guests and features modern amenities throughout. Perfect for families, groups, and extended stays seeking comfort, convenience, and an authentic DC neighborhood experience in one of the city\'s most historic and walkable areas.',
    amenities: [
      'Air Conditioning',
      'Heating',
      'WiFi',
      'TV',
      'Dedicated Workspace',
      'Kitchen',
      'Kitchenette',
      'Refrigerator',
      'Microwave',
      'Dishwasher',
      'Coffee Maker',
      'Cooking Basics',
      'Dishes & Silverware',
      'Wine Glasses',
      'Dining Table',
      'Washer',
      'Dryer',
      'Iron',
      'Hangers',
      'Bed Linens',
      'Clothing Storage',
      'Room-Darkening Shades',
      'Bathtub',
      'Hair Dryer',
      'Shampoo',
      'Conditioner',
      'Shower Gel',
      'First Aid Kit',
      'Smoke Alarm',
      'Carbon Monoxide Alarm',
      'Free Street Parking'
    ]
  },
  {
    id: 'cv-002',
    name: 'Capitol Hill 3',
    location: '220 14th Street SE, Capitol Hill, Washington DC',
    coordinates: { lat: 38.8849, lng: -76.9831 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/capital-hill-3/59d48b',
    bedrooms: 6,
    bathrooms: 3.5,
    sleeps: 10,
    pricePerNight: 450,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 3 },
      { type: 'Sofa Bed', count: 3 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/7ow6skgq_03.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/ehajb45l_15.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/cg8mttcj_20.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/ktxhom69_27.jpg'
    ],
    description: 'Welcome to Your Capitol Hill Retreat! Experience the charm and history of Washington, D.C. from this cozy and modern unit, perfectly located in the heart of historic Capitol Hill. Just steps away from iconic landmarks like the U.S. Capitol, Supreme Court, Museums, and Library of Congress, this home offers both comfort and convenience for your stay. Whether you\'re here for sightseeing or work, you\'ll appreciate the quiet, tree-lined streets, local cafes, and vibrant atmosphere.',
    amenities: [
      'Air Conditioning',
      'Heating',
      'WiFi',
      'TV',
      'Dedicated Workspace',
      'Kitchen',
      'Kitchenette',
      'Refrigerator',
      'Microwave',
      'Dishwasher',
      'Coffee Maker',
      'Cooking Basics',
      'Dishes & Silverware',
      'Wine Glasses',
      'Dining Table',
      'Washer',
      'Dryer',
      'Iron',
      'Hangers',
      'Bed Linens',
      'Clothing Storage',
      'Room-Darkening Shades',
      'Bathtub',
      'Hair Dryer',
      'Shampoo',
      'Conditioner',
      'Shower Gel',
      'First Aid Kit',
      'Smoke Alarm',
      'Carbon Monoxide Alarm',
      'Free Street Parking'
    ]
  },
  {
    id: 'cv-003',
    name: 'Capitol Hill 4',
    location: '220 14th Street SE, Capitol Hill, Washington DC',
    coordinates: { lat: 38.8845, lng: -76.9835 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/modern-capitol-hill-townhouse-%257C-rooftop-retreat-for-dc-trips-%2526-corporate-stays/4483f7',
    bedrooms: 6,
    bathrooms: 4.5,
    sleeps: 11,
    pricePerNight: 475,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 2 },
      { type: 'Bunk Bed', count: 1 },
      { type: 'Sofa Bed', count: 2 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/6uuwq9ym_09.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/sxqk29db_06.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/m89g5c4n_19%20-%20220%2014th%20St%20SE%2C%234_final.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/abaj9lqp_04.jpg'
    ],
    description: 'Welcome to your ideal Washington, DC home base, a 3-bedroom townhouse with a private rooftop terrace in the heart of Capitol Hill. Perfect for tourists exploring DC, family vacations, and corporate travelers, consultants, government contractors, traveling nurses, and work groups, this spacious home blends comfort, style, and functionality for both short visits and extended stays.',
    amenities: [
      'Air Conditioning',
      'Heating',
      'WiFi',
      'TV',
      'Dedicated Workspace',
      'Kitchen',
      'Kitchenette',
      'Refrigerator',
      'Microwave',
      'Dishwasher',
      'Coffee Maker',
      'Cooking Basics',
      'Dishes & Silverware',
      'Wine Glasses',
      'Dining Table',
      'Washer',
      'Dryer',
      'Iron',
      'Hangers',
      'Bed Linens',
      'Clothing Storage',
      'Room-Darkening Shades',
      'Bathtub',
      'Hair Dryer',
      'Shampoo',
      'Conditioner',
      'Shower Gel',
      'First Aid Kit',
      'Smoke Alarm',
      'Carbon Monoxide Alarm',
      'Free Street Parking',
      'Private Rooftop'
    ]
  },
  {
    id: 'cv-004',
    name: 'Capitol View 1 Townhouse Condo',
    location: '1337 Taylor St NW, Washington DC',
    coordinates: { lat: 38.9422, lng: -77.0273 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/charming-dc-stay-near-monuments-%2526-metro/01290c',
    bedrooms: 3,
    bathrooms: 2,
    sleeps: 6,
    pricePerNight: 295,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 1 },
      { type: 'Bunk Bed', count: 1 },
      { type: 'Sofa Bed', count: 1 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/2aduuwrk_01.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/qja38rle_16.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/c9a79isz_19.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/1y9o9n34_29.jpg'
    ],
    description: 'Welcome to our serene oasis in the heart of the city! Kick back and relax in this calm, stylish space designed with your comfort in mind. Our Airbnb listing boasts modern amenities, tastefully curated decor, and a peaceful ambiance. Whether you\'re in town for business or pleasure, our home provides the perfect escape from the hustle and bustle. Nestled in a safe and convenient location, you\'re just minutes away from local attractions and eateries.',
    amenities: [
      'Air Conditioning',
      'Heating',
      'Hot Water',
      'WiFi',
      'TV',
      'Sound System',
      'Dedicated Workspace',
      'Kitchen',
      'Kitchenette',
      'Refrigerator',
      'Freezer',
      'Microwave',
      'Dishwasher',
      'Oven',
      'Stove',
      'Coffee Maker',
      'Hot Water Kettle',
      'Toaster',
      'Blender',
      'Cooking Basics',
      'Baking Sheet',
      'Dishes & Silverware',
      'Wine Glasses',
      'Dining Table',
      'Washer',
      'Dryer',
      'Iron',
      'Hangers',
      'Bed Linens',
      'Clothing Storage',
      'Extra Pillows & Blankets',
      'Room-Darkening Shades',
      'Essentials',
      'Bathtub',
      'Hair Dryer',
      'Shampoo',
      'Conditioner',
      'Shower Gel',
      'Body Soap',
      'Cleaning Products',
      'First Aid Kit',
      'Fire Extinguisher',
      'Smoke Alarm',
      'Carbon Monoxide Alarm',
      'Trash Compactor',
      'Free Parking on Premises',
      'Free Street Parking',
      'Paid Parking on Premises',
      'Backyard',
      'Outdoor Dining Area',
      'Long Term Stays Allowed'
    ]
  },
  {
    id: 'cv-005',
    name: 'Capitol View2 Townhouse Condo',
    location: '1337 Taylor St NW, Washington DC',
    coordinates: { lat: 38.9424, lng: -77.0271 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/charming-dc-retreat-%257C-perfect-for-sightseeing-%2526-corporate-stays/ec947d',
    bedrooms: 4,
    bathrooms: 3,
    sleeps: 8,
    pricePerNight: 375,
    featured: false,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 2 },
      { type: 'Bunk Bed', count: 1 },
      { type: 'Sofa Bed', count: 1 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/kqx6g6wm_01.jpg',
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/m1cqj8ri_16.jpg',
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/kci1us9d_27.jpg',
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/humx5qkj_29.jpg'
    ],
    description: 'Welcome to our serene oasis in the heart of the city! Kick back and relax in this calm, stylish space designed with your comfort in mind. Our Airbnb listing boasts modern amenities, tastefully curated decor, and a peaceful ambiance. Whether you\'re in town for business or pleasure, our home provides the perfect escape from the hustle and bustle. Nestled in a safe and convenient location, you\'re just minutes away from local attractions and eateries.',
    amenities: [
      'Air Conditioning',
      'Backyard',
      'Baking Sheet',
      'Bathtub',
      'Bed Linens',
      'Blender',
      'Body Soap',
      'Carbon Monoxide Alarm',
      'Cleaning Products',
      'Clothing Storage',
      'Coffee',
      'Coffee Maker',
      'Conditioner',
      'Cooking Basics',
      'Dedicated Workspace',
      'Dining Table',
      'Dishes & Silverware',
      'Dishwasher',
      'Dryer',
      'Essentials',
      'Extra Pillows & Blankets',
      'Fire Extinguisher',
      'First Aid Kit',
      'Free Parking on Premises',
      'Free Street Parking',
      'Freezer',
      'Hair Dryer',
      'Hangers',
      'Heating',
      'Hot Water',
      'Hot Water Kettle',
      'Iron',
      'Kitchen',
      'Kitchenette',
      'Long Term Stays Allowed',
      'Microwave',
      'Outdoor Dining Area',
      'Oven',
      'Paid Parking on Premises',
      'Refrigerator',
      'Room-Darkening Shades',
      'Shampoo',
      'Shower Gel',
      'Smoke Alarm',
      'Sound System',
      'Stove',
      'Toaster',
      'Trash Compactor',
      'TV',
      'Washer',
      'WiFi',
      'Wine Glasses'
    ]
  },
  {
    id: 'cv-006',
    name: 'Capitol View 3 Penthouse w/ Rooftop',
    location: '1337 Taylor St NW, Washington DC',
    coordinates: { lat: 38.9420, lng: -77.0275 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/penthouse-with-rooftop-dc-condo/46f393',
    bedrooms: 4,
    bathrooms: 2.5,
    sleeps: 8,
    pricePerNight: 425,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 2 },
      { type: 'Bunk Bed', count: 1 },
      { type: 'Sofa Bed', count: 1 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/j6kdhvi6_5b7ae768-8208-496a-8d2a-f4013464b212.webp',
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/4ozgrrsk_140dd267-8ba9-4412-b06f-aebfdd53af0d.webp',
      'https://customer-assets.emergentagent.com/job_skylinerentals/artifacts/uz0nt4rs_d665c317-9dde-4607-82e5-07f6a5da3b14.webp'
    ],
    description: 'Welcome to Capitol View Penthouse, a modern top-floor escape in the heart of Petworth perfectly suited for DC tourists, corporate travelers, traveling nurses, consultants, government contractors, and work groups. Whether you\'re visiting the capital\'s iconic landmarks or are in town for an extended business stay, this penthouse offers the ideal blend of comfort, convenience, and elevated city living.',
    amenities: [
      'Air Conditioning',
      'Backyard',
      'Baking Sheet',
      'Bathtub',
      'Bed Linens',
      'Blender',
      'Body Soap',
      'Cleaning Products',
      'Clothing Storage',
      'Coffee',
      'Coffee Maker',
      'Conditioner',
      'Cooking Basics',
      'Crib',
      'Dedicated Workspace',
      'Dining Table',
      'Dishes & Silverware',
      'Dishwasher',
      'Dryer',
      'Essentials',
      'Extra Pillows & Blankets',
      'Fire Extinguisher',
      'First Aid Kit',
      'Free Parking on Premises',
      'Freezer',
      'Hair Dryer',
      'Hangers',
      'Heating',
      'Hot Water',
      'Hot Water Kettle',
      'Iron',
      'Kitchen',
      'Kitchenette',
      'Microwave',
      'Outdoor Furniture',
      'Oven',
      'Private Rooftop',
      'Refrigerator',
      'Room-Darkening Shades',
      'Shampoo',
      'Shower Gel',
      'Smoke Alarm',
      'Sound System',
      'Stove',
      'Toaster',
      'Trash Compactor',
      'TV',
      'Washer',
      'WiFi',
      'Wine Glasses'
    ]
  },
  {
    id: '8457ce82-f8f8-4ee0-b6d1-36f47939979b',
    name: 'Capitol Hill 2',
    location: '220 14th Street SE, Capitol Hill, Washington DC',
    coordinates: { lat: 38.8851, lng: -76.9829 },
    bookingUrl: 'https://www.bookeddirectly.com/g/washington/townhouse-at-capitol-hill-2-with-roof-top/78671b',
    bedrooms: 3,
    bathrooms: 3.5,
    sleeps: 9,
    pricePerNight: 256,
    featured: true,
    available: true,
    bedConfiguration: [
      { type: 'Queen Bed', count: 3 },
      { type: 'Sofa Bed', count: 2 }
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/9mfvmcis_03.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/bf8cs12m_07.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/yjke79kl_30.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/io3ph70h_33.jpg',
      'https://customer-assets.emergentagent.com/job_fad28a4e-b2cd-4400-96b6-93b3666d4118/artifacts/4wc9f5cw_37.jpg'
    ],
    description: 'Welcome to Your Capitol Hill Retreat! Experience the charm and history of Washington, D.C. from this cozy and modern unit, perfectly located in the heart of historic Capitol Hill. Just steps away from iconic landmarks like the U.S. Capitol, Supreme Court, Museums, and Library of Congress, this home offers both comfort and convenience for your stay. Whether you\'re here for sightseeing or work, you\'ll appreciate the quiet, tree-lined streets, local cafes, and vibrant atmosphere.',
    amenities: [
      'Air Conditioning',
      'Heating',
      'WiFi',
      'TV',
      'Dedicated Workspace',
      'Kitchen',
      'Kitchenette',
      'Refrigerator',
      'Microwave',
      'Dishwasher',
      'Coffee Maker',
      'Cooking Basics',
      'Dishes & Silverware',
      'Wine Glasses',
      'Dining Table',
      'Washer',
      'Dryer',
      'Iron',
      'Hangers',
      'Bed Linens',
      'Clothing Storage',
      'Room-Darkening Shades',
      'Bathtub',
      'Hair Dryer',
      'Shampoo',
      'Conditioner',
      'Shower Gel',
      'First Aid Kit',
      'Smoke Alarm',
      'Carbon Monoxide Alarm',
      'Free Street Parking',
      'Private Rooftop'
    ]
  }
];

export const companyInfo = {
  name: 'Capitol View Stays',
  tagline: 'Book Directly for Best Rates and Offers',
  description: 'Capitol View Stays offers fully furnished, upscale short-term rentals in prime Washington DC locations. We specialize in providing comfortable, well-appointed accommodations for families, professionals, work groups, and extended stays.',
  email: 'capitolviewstays@gmail.com',
  phone: '+(571) 507-5650',
  alternatePhone: '+1 (703) 980-2071',
  instagram: '@capitolviewstay',
  address: 'Washington, DC',
  yearEstablished: 2018,
  about: 'Founded in 2018, Capitol View Stays has become a trusted name in Washington DC short-term rentals. Our mission is to provide guests with exceptional accommodations that feel like home, combined with the convenience and amenities of a hotel. Each property is carefully selected for its location, maintained to the highest standards, and fully equipped to meet the needs of modern travelers. We pride ourselves on transparent pricing, attentive service, and creating memorable experiences for our guests.',
  whyBookDirect: [
    { title: 'Best Price Guarantee', description: 'Save 10-15% compared to OTA platforms' },
    { title: 'No Hidden Fees', description: 'Transparent pricing with no surprises' },
    { title: 'Direct Communication', description: 'Speak directly with property managers' },
    { title: 'Flexible Policies', description: 'Full refund for cancellations 30+ days before arrival' },
    { title: 'Personalized Service', description: 'Tailored recommendations and support' }
  ]
};

export const houseRules = {
  checkIn: '3:00 PM',
  checkOut: '11:00 AM',
  rules: [
    {
      title: 'No Smoking',
      description: 'Smoking is strictly prohibited in all properties. A $300 cleaning fee will be charged for violations.'
    },
    {
      title: 'Pets',
      description: 'Pets are not allowed unless explicitly stated in the property listing. Unauthorized pets will incur a $200 fee.'
    },
    {
      title: 'Guests',
      description: 'Only registered guests are allowed. Maximum occupancy must be respected at all times. Undeclared or additional guests may result in additional charges or cancellation of the stay without refund.'
    },
    {
      title: 'Parties & Events',
      description: 'No parties or events are permitted. Excessive noise, disruptive behavior, or illegal activity will result in immediate eviction without refund.'
    },
    {
      title: 'Noise',
      description: 'Please respect quiet hours from 10:00 PM to 8:00 AM. Be considerate of neighbors.'
    },
    {
      title: 'Cleanliness',
      description: 'Please maintain the property in good condition. Leave dishes clean and take out trash before departure.'
    },
    {
      title: 'Damages & Incidentals',
      description: 'Guests are financially responsible for any damage, loss, or excessive cleaning required during their stay. A valid payment method will be kept on file to cover incidental charges or damages, if necessary.'
    }
  ],
  cancellationPolicy: 'Cancellations made 30 days or more prior to arrival are eligible for a full refund. Cancellations made 29 days or fewer before arrival are non-refundable. To cancel a reservation, guests must submit a written request via email to capitolviewstays@gmail.com',
  termsAndConditions: {
    title: 'Terms & Conditions of Reservation',
    sections: [
      {
        title: 'Reservation & Payment',
        content: 'A valid credit or debit card is required to secure all reservations. Full payment is due at the time of booking. By submitting payment, you confirm that you are authorized to use the payment method provided and that sufficient funds are available.'
      },
      {
        title: 'Check-In / Check-Out',
        content: 'Check-in: 3:00 PM or later on the day of arrival. Check-out: By 11:00 AM on the day of departure. Late check-out requests are subject to availability and may incur additional fees.'
      },
      {
        title: 'Occupancy',
        content: 'The total number of guests must not exceed the maximum occupancy listed on the reservation. Undeclared or additional guests may result in additional charges or cancellation of the stay without refund.'
      },
      {
        title: 'Guest Conduct',
        content: 'Guests are expected to respect the property, neighbors, and community at all times. Excessive noise, parties, disruptive behavior, or illegal activity will result in immediate eviction without refund.'
      },
      {
        title: 'Amenities & Services',
        content: 'Amenities are provided as-is. Capital View Stays is not responsible for service interruptions related to utilities, internet, or other services beyond our control.'
      },
      {
        title: 'Liability Disclaimer',
        content: 'Capital View Stays and its owners are not liable for accidents, injuries, illness, or loss of personal property occurring on the premises. Guests assume all responsibility for their personal belongings and well-being during their stay.'
      },
      {
        title: 'Privacy Policy',
        content: 'Personal information collected during the booking process is used solely to process and manage your reservation.'
      },
      {
        title: 'Agreement & Acknowledgment',
        content: 'By completing your booking, you confirm your agreement to all Terms and Conditions listed above. Failure to comply may result in termination of your reservation without refund.'
      }
    ]
  }
};

// Mock function to handle booking inquiries
export const submitBookingInquiry = (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Booking inquiry submitted:', bookingData);
      const inquiry = {
        id: `INQ-${Date.now()}`,
        ...bookingData,
        status: 'pending',
        createdAt: new Date().toISOString()
      };
      // Store in localStorage for demo
      const inquiries = JSON.parse(localStorage.getItem('bookingInquiries') || '[]');
      inquiries.push(inquiry);
      localStorage.setItem('bookingInquiries', JSON.stringify(inquiries));
      resolve(inquiry);
    }, 1000);
  });
};

// Mock function to handle newsletter signups
export const submitNewsletter = (email, firstName = '', lastName = '') => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const subscribers = JSON.parse(localStorage.getItem('newsletterSubscribers') || '[]');
      const exists = subscribers.find(sub => sub.email.toLowerCase() === email.toLowerCase());
      
      if (exists) {
        reject(new Error('This email is already subscribed to our newsletter.'));
      } else {
        const subscriber = {
          email,
          firstName,
          lastName,
          subscribedAt: new Date().toISOString()
        };
        subscribers.push(subscriber);
        localStorage.setItem('newsletterSubscribers', JSON.stringify(subscribers));
        console.log('Newsletter subscription:', subscriber);
        resolve(subscriber);
      }
    }, 800);
  });
};

// Mock function to handle contact form submissions
export const submitContactForm = (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', contactData);
      const submission = {
        id: `CONTACT-${Date.now()}`,
        ...contactData,
        submittedAt: new Date().toISOString()
      };
      // Store in localStorage for demo
      const contacts = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      contacts.push(submission);
      localStorage.setItem('contactSubmissions', JSON.stringify(contacts));
      resolve(submission);
    }, 1000);
  });
};